import React from "react";
import MyTransactions from "../components/dashboard/MyTransactions";
import "../styles/transactions.css";
import MarketMarquee from "../components/stocks/MarketMarque";

function TradeTransactions({ user }) {
  return (
    <div className="transactions-page">
      <MarketMarquee />
      <h2>Investment Transactions</h2>
      <MyTransactions user={user} showFilter={true} account={["Investments", "Trading"]} />
    </div>
  );
}

export default TradeTransactions;